<template>
	<div>
		<div v-if="isReconnect" class="reconnect-feedback"> Reconectando... </div>
		<section>
			<div id="spearhead"> 
				<div v-if="protocol || personContact.name || personContact.phone || queue" class="d-flex">
					<div class="spearhead-element">
						<span><i class="fas fa-clipboard"></i><b>Protocolo</b></span>
						<p v-if="protocol">{{protocol}}</p>
						<p v-else>----------</p>
					</div>
					<div class="spearhead-element">
						<span><i class="fas fa-user"></i><b>Cliente</b></span>
						<p v-if="personContact.name">{{personContact.name}}</p>
						<p v-else>----------</p>
					</div>
					<div class="spearhead-element">
						<span><i class="fas fa-phone"></i><b>Telefone</b></span>
						<p v-if="personContact.phone">{{personContact.phone}}</p>
						<p v-else>----------</p>
					</div>
					<div class="spearhead-element">
						<span><i class="fas fa-headset"></i><b>Fila de Atendimento</b></span>
						<p v-if="queue">{{queue}}</p>
						<p v-else>----------</p>
					</div>
					<div class="spearhead-element spearhead-element--action" @click="openNewTask">
						<i class="fas fa-plus"></i> Tarefa
					</div>
				</div>
			</div>
		</section>
		<TaskFormModal ref="taskFormModal" modal-id="task-form-modal-spearhead" :priorities-list="prioritiesList"
			:statuses-list="statusesList" :groups-list="groupsList" :users-list="usersList"
			:reasons-list="reasonsList" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TaskFormModal from '../tasks/TaskFormModal.vue';
import { taskManagerAxios } from '../tasks/connections/taskApiConnection.js';
const TASKMANAGER_URL = `${window.location.protocol}//${window.location.hostname}:3023`;

export default {
	components: { TaskFormModal },
    data() {
        return {
            interval: '',
            time: '',
            timeFormat: '',
			protocol: '',
			personContact: {
				'name': '',
				'phone': '',
			},
			queue: '',
			session: '',
			type: '',
			prioritiesList: [],
			statusesList: [],
			groupsList: [],
			usersList: [],
			reasonsList: [],
			metaLoaded: false,
        }
    },
	methods: {
		...mapActions(['']),
		async openNewTask() {
			if (!this.metaLoaded) {
				await this.fetchTaskMeta();
			}

			const currentUserId = window.user.getIdPrefix();
			const currentUserName = window.user.getName();

			const pendente = this.statusesList.find(s => s.name.toLowerCase().includes('pendente'));
			const userGroup = this.groupsList.find(g =>
				Array.isArray(g.members) && g.members.some(m => m.id === currentUserId)
			);

			const description = [
				this.queue ? `Atendimento feito na fila ${this.queue}` : null,
				this.personContact.name ? `para o cliente ${this.personContact.name}` : null,
				this.personContact.phone ? `com o telefone ${this.personContact.phone}` : null,
			].filter(Boolean).join(', ');

			const defaults = {
				channel: this.type === 'phone' ? 'telefone' : 'whatsapp',
				ref_protocol: this.protocol || '',
				description: description || '',
				status_id: pendente?._id ?? null,
			};

			this.$refs.taskFormModal.open(defaults);
		},
		async fetchTaskMeta() {
			try {
				const [priorities, statuses, groups, users, reasons] = await Promise.all([
					taskManagerAxios.get('/priorities'),
					taskManagerAxios.get('/statuses'),
					taskManagerAxios.get('/groups'),
					axios.get('/simple-list-users'),
					taskManagerAxios.get('/reasons'),
				]);
				this.prioritiesList = priorities.data ?? [];
				this.statusesList = statuses.data ?? [];
				this.groupsList = groups.data ?? [];
				this.usersList = users.data ?? [];
				this.reasonsList = reasons.data ?? [];
				this.metaLoaded = true;
			} catch (e) {
				console.error('[PontaDeLanca] fetchTaskMeta:', e);
			}
		},
		formatCpf(cpf) {
			try {
				cpf = cpf.replace(/[^\d]/g, "");
				return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			} catch(e) {
				return cpf;
			}
		},
		formatPersonData() {
			try {
				this.person.fullName = this.person.fullName.trim();
			} catch(e) {
				console.error('Cliente sem nome');
			}

			return `<b>Nome:</b> ${this.person.fullName} <b>Idade:</b> ${this.person.age} <b>Data de Nascimento:</b> ${this.person.birthday} <b>CPF:</b> ${this.formatCpf(this.person.CPF)}`;
		},
		formatPersonContact() {
			return `<b>Numero:</b> ${this.personContact.phone}  <b>Protocolo:</b> ${this.protocol}`;
		},
		formathealthInssurance() {
			return `<b>Convenio:</b> ${this.healthInssurance.name} - <b>Registro:</b> ${this.healthInssurance.id}`;
		},
		formatAddress() {
			return `${this.ende.address}, ${this.ende.num}, ${this.ende.city} - ${this.ende.CEP}`;
		},
		async setClientData(client) {
			let clientName = '';
			let phoneEdited = '';
			this.protocol = "";
			this.queue = "";

			if(this.getPhone){
				if(client.type == 'chat'){
					let phoneArr = client.phone.split('@');
					phoneEdited = this.formTelefone(phoneArr[0].substr(2));
				}
				this.personContact = {
					'name': client.name || phoneEdited,
					'phone': phoneEdited,	
				}
				if(client.queue == 'entrante'){
					this.queue = 'Atendimento Ativo';
				}
				else {
					this.queue = client.queue;
				}
				this.protocol = client.protocol;
			}
			
			if(client.phone && client.type == 'phone'){
				this.protocol = client.protocol;
				this.queue = client.queue;
				clientName = await axios(`/share-client-cnpj?share=${client.phone}`).then(response => {
					if(response.data.length > 0){
						return response.data[0].name;
					}
					else{
						return this.formTelefone(client.phone);
					}
				})
				this.personContact = {
					'name': clientName,
					'phone': this.formTelefone(client.phone),
				}
			}
		},
		formTelefone(tel) {
			if( (tel.length == 10) || (tel.length == 11) ) {
				const v1 = tel.replace(/\D/g,"");
				const v2 = v1.replace(/^(\d{2})(\d)/g,"($1) $2");
				const v3 = v2.replace(/(\d)(\d{4})$/,"$1-$2");
				
				return v3;
			}
			tel=tel.replace(/\D/g,"")
			tel=tel.replace(/^(\d)/,"+$1")
			tel=tel.replace(/(.{3})(\d)/,"$1($2")
			tel=tel.replace(/(.{6})(\d)/,"$1)$2")
			if(tel.length == 12) {
				tel=tel.replace(/(.{1})$/,"-$1")
			}
			else if (tel.length == 13) {
				tel=tel.replace(/(.{2})$/,"-$1")
			}
			else if (tel.length == 14) {
				tel=tel.replace(/(.{3})$/,"-$1")
			}
			else if (tel.length == 15) {
				tel=tel.replace(/(.{4})$/,"-$1")
			}
			else if (tel.length > 15) {
				tel=tel.replace(/(.{4})$/,"-$1")
			}
			tel=tel.replace("("," (");
			tel=tel.replace(")",") ");

			return tel;
		}
	},
    computed: {
        ...mapGetters(['isReconnect', 'getDataConnectLine', 'getPhone']),
    },
	watch: {
		getDataConnectLine(val) {
			localStorage.setItem("clienteAtual", JSON.stringify(val));
			this.hasData = !!Object.keys(val).length;
			this.setClientData(val);

			if(Object.keys(val).length === 0){
				this.personContact = {
					'name': '',
					'phone': ''
				}
				this.protocol = ''
				this.queue = ''
			}
		}
	},
	mounted() {
		if (!localStorage.getItem("clienteAtual")) {
			this.hasData = false;
			return ;
		}

		const clienteAtual = JSON.parse(localStorage.getItem("clienteAtual"));
		if (Object.keys(clienteAtual).length) {
			this.hasData = true;
			this.setClientData(clienteAtual);
		}
	}
}
</script>

<style scoped>
	#spearhead {
		display: flex;
		position: absolute;
    	left: 50%;
    	transform: translateX(-50%);
    	z-index: 1;
    	border-radius: 0px 0px 14px 14px;
    	font-size: 11px;
    	background-color: white;
    	margin: 2px;
    	box-shadow: -1px 5px 7px 0px #9f9999;
		transition: 0.7s;
		transition-timing-function: ease;
		height: max-content;
	}
	.spearhead-element{
    	display: flex;
    	flex-direction: column;
    	text-align: center;
    	border-right: 1px solid lightgray;
    	border-left: 1px solid lightgray;
    	padding: 0px 10px;
	}
	.spearhead-element--action {
		justify-content: center;
		border-radius: 0px 0px 12px 0px;
		background-color: #757575;
		color: #fff;
		cursor: pointer;
		font-weight: bold;
	}
	.spearhead-element span{
		font-size: 12px;
		text-align: center;
	}
	.center {

		display: flex;
		align-items: center;
		justify-content: center;
	}
	.reconnect-feedback{
		display: flex;
		justify-content: center;
		width: 100%;
		background-color: gray;
		color: white;
	}

	.parte-cima{
		box-shadow: 5px 3px 6px -6px black;
		padding: 1px 5px 2px 20px;
		background-color: #ECF0F1;
		max-height: 10em;
		overflow-x: auto;
	}
	.row{
		margin-right: 0 !important;
	}
	::-webkit-scrollbar {
	 		width: 0.18rem;
	 	}
	 	::-webkit-scrollbar-track {
	 		background: #f38630;
	 	}
	 	::-webkit-scrollbar-thumb {
	 		background: #1c869a;
	 	}
	.espaco-lado-lado{
		max-width: 270px;
		width: 100%;
		margin: 0.1em 0 0.1em 0;
    }
    .img{
        height: 1.7em;
    }
	b{
		font-size: 1.1em;
    	margin-left: 0.5em;
	}
	p {
		margin: 0 5px;
	}
	span{
		font-size: 20px;
	}
</style>
